module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('meta', {
    attrs: {
      "content": "text/html; charset=utf-8",
      "http-equiv": "Content-Type"
    }
  }), _c('meta', {
    attrs: {
      "content": "text/html; charset=UTF-8"
    }
  }), _c('title', [_vm._v(" STRANGE FIRE ")]), _c('link', {
    attrs: {
      "href": "default.css",
      "rel": "stylesheet",
      "type": "text/css"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ct",
    attrs: {
      "id": "p0021-01-0"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }), _c('a', {
    attrs: {
      "href": "#/chapter2#ii5",
      "id": "tt5"
    }
  }, [_vm._v("ONE")])]), _vm._v(" "), _c('p', {
    staticClass: "ser1"
  }, [_c('img', {
    staticClass: "maxwidth",
    attrs: {
      "alt": "978140020518_0007_002.jpg",
      "src": "images/978140020518_0007_002.jpg"
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "ct1",
    attrs: {
      "id": "p0021-02-1"
    }
  }, [_c('a', {
    attrs: {
      "href": "#/chapter2#ii5"
    }
  }, [_vm._v("M"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OCKING THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_c('span', {
    staticClass: "dcap"
  }, [_vm._v("A")]), _vm._v("n editorial column from an African news website recently came across my desk. As I read it, I was struck by its blunt honesty and insightfulness. The piece, though penned by a Pentecostal man, is sharply critical of the chaos that characterizes the Charismatic Movement in that part of the world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("After blasting the “bizarre spirit-possession” and “odd ritual practices” of Pentecostalism in a general way, the author focuses on speaking in tongues. Observing a man supposedly filled with the Holy Spirit, he described the frenetic scene with these words:")]), _vm._v(" "), _c('p', {
    staticClass: "ext1"
  }, [_vm._v("One sees the man’s body forcibly shaking in spasms, with the hands trembling, the voice quivering in such staccato mumblings as: Je-Je-Je-Jee-sus . . . Jeee-sus . . . Je-Je-Je-Jee-sus . . . aassh . . . aassh . . . ah . . . aassh Jee-sus.")]), _vm._v(" "), _c('p', {
    staticClass: "ext2"
  }, [_vm._v("Then follows some stuttering tongues-speaking: shlababababa—Jah-Jeey-balika—a syndrome which an American psychologist "), _c('span', {
    attrs: {
      "id": "page_p0021-03-2_30_peter"
    }
  }, [_vm._v("Peter")]), _vm._v(" Brent calls “a born-again fixation,” and an observer brands as “a Pentecostal anthem.” Only recently a reverend minister of an orthodox church queried, “If the possessed voodoo priest says: ‘shiri-bo-bo-bo-boh’ in a staccato stammer over his "), _c('a', {
    attrs: {
      "id": "page4"
    }
  }, [_vm._v("black whisk he holds, and the possessed born-again Christian rattles: ‘shlaba-ba-bah-shlabalika’ over his Bible, what can be the difference?”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw1_5",
      "id": "wt1_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("1")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The rhetorical question is left ringing in the ears of the reader.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The author continues with a stinging exposé of a Pentecostal church service—inviting his readers to “watch some possessed prayerful: some, especially women, begin to hop about on one leg like grasshoppers let loose, and others roll on the floor, overturning benches and chairs. Order and discipline—these have gone to the winds, giving way to rowdy pandemonium, a babble of din.” In disbelief, he poses the obvious question: “Can that be the biblical way to serve God?” Again, the rhetorical question remains unanswered.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("He then recounts the story of a Pentecostal prayer meeting held just a few weeks earlier, in which a “Spirit-filled” woman fell down in ecstasy and knocked over a boy who was speaking in tongues. After crashing into the pews, the boy got up, nursing a bloody lip, and lamented, “Oh why?” in his own native language.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The incident raises more unanswerable questions. Our author wonders why the “tongue-speaking spirit should, in a split second, leave the bleeding lips and speak in native dialect.” But more important, he wants to know, "), _c('i', [_vm._v("how could the Holy Spirit be responsible for this kind of mayhem?")]), _vm._v(" As he puts it, “Indeed, this incident raised the eyebrows of onlookers and anxious visitors: how [was it] that the Holy Spirit in someone should knock down the Holy Spirit in another so [as] to hurt him? Is the Holy Spirit now made to be a pugilist, or dancing boxer like old-time Cassius Clay to give a knockout? All were mystif[ied].” Their bewilderment is understandable. Surely the Spirit of God would not injure one of His own. But that realization forces them into an impossible dilemma: If the Holy Spirit is not behind the hype, then who is? ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Though that specific account comes out of Africa, the general description it gives could fit Pentecostal and charismatic congregations in any part of the world."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw2_5",
      "id": "wt2_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("2")])]), _vm._v(" The questions raised by the editorial’s author are the questions every believer should ask, especially those who are part of charismatic churches. Why does the modern version of speaking in tongues parallel pagan worship practices? How can a God of order be honored by confusion and disarray?"), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v(" Does the Holy Spirit really cause people to fall down like bowling pins? Why has the Charismatic Movement turned Him into something He is not? And, most important, what happens to people when they realize He’s not the one behind the hysteria?")])]), _c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_c('p', {
    staticClass: "h3"
  }, [_vm._v("D"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ISHONORING THE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("It is deeply ironic that a movement supposedly devoted to honoring and emphasizing the ministry of the Holy Spirit in fact treats Him with such casual contempt and condescension. In practice, charismatics often seem to reduce the Spirit of God to a "), _c('i', [_vm._v("force")]), _vm._v(" or a "), _c('i', [_vm._v("feeling.")]), _vm._v(" Their bizarre practices and their exaggerated claims make Him look like a "), _c('i', [_vm._v("farce")]), _vm._v(" or a "), _c('i', [_c('span', {
    attrs: {
      "id": "page_p0023-03-3_31_fraud"
    }
  }, [_vm._v("fraud")])]), _vm._v(". The sovereign glory of His holy person is exchanged repeatedly for the hollow shell of human imagination. The result is a movement whose most visible leaders—televangelists, faith healers, self-proclaimed prophets, and prosperity preachers—boldly claim His name while simultaneously dragging it through the mud.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page5"
    }
  }, [_vm._v("The number of scams and "), _c('span', {
    attrs: {
      "id": "page_p0023-03-3_29_scandals"
    }
  }, [_vm._v("scandals")]), _vm._v(" that continually arise out of the charismatic world is staggering. J. Lee Grady, contributing editor to "), _c('i', [_vm._v("Charisma")]), _vm._v(" magazine, acknowledged in "), _c('i', [_vm._v("Christianity Today")]), _vm._v(" that the charismatic world “has been shaken to its core in recent years by a number of high-profile leaders who have divorced or had moral failures. Many charismatics I know are troubled by this, and they feel it is time for deep introspection, repentance and a rejection of the shallow, celebrity Christianity that has typified much of our movement.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw3_5",
      "id": "wt3_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("3")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("One of the fundamental claims of charismatic teaching is that charismatics are privy to a sanctifying spiritual power not available to every believer. Those who have had a charismatic experience have been baptized with the Spirit, they say—and that supernaturally empowers obedience, fosters holiness, and produces the fruit of the Spirit. If their claims were true, charismatics ought to be producing leaders renowned for Christlikeness rather than flamboyance. Moral failures, financial chicanery, and public scandals would be comparatively rare in their movement.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("But charismatics dominate the list of "), _c('span', {
    attrs: {
      "id": "page_p0023-03-3_16_celebrity"
    }
  }, [_vm._v("celebrity pastors")]), _vm._v(" and televangelists"), _c('a', {
    attrs: {
      "id": "page6"
    }
  }, [_vm._v(" who have brought disgrace on the name of Christ over the past three decades—from Jim Bakker and Jimmy Swaggart to Ted Haggard and Todd Bentley. An entry entitled “List of Scandals Involving Evangelical Christians” on the popular website "), _c('i', [_vm._v("Wikipedia")]), _vm._v(" identified fifty well-known, publicly disgraced church leaders. The article indiscriminately labels the group “evangelical,” but at least thirty-five of those listed are from Pentecostal and charismatic backgrounds."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw4_5",
      "id": "wt4_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4")]), _vm._v(" A "), _c('i', [_vm._v("Wikipedia")]), _vm._v(" entry may not be authoritative in its use of doctrinal labels, but it serves as an accurate barometer of public perception. When charismatic leaders fail, whether for moral failure or financial impropriety, it is evangelicalism’s reputation that gets besmirched. More important, the name of Christ is tarnished and the Spirit of God dishonored.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Bizarre doctrines and behavior have become so commonplace within the Charismatic Movement that they hardly make headlines anymore. Unbiblical practices—like speaking gibberish, falling backward to the floor, laughing uncontrollably, or writhing on the ground—are seen as necessary evidence that the Spirit is moving. "), _c('span', {
    attrs: {
      "id": "page_p0024-02-2_18_youtube"
    }
  }, [_vm._v("YouTube")]), _vm._v(" has a seemingly endless collection of charismatic nonsense that is blatantly blasphemous—whole congregations doing the “Holy Ghost Hokey Pokey,” people “tokin’ the Ghost” (pretending to inhale the Holy Spirit and get high, as if He were an invisible reefer), and women writhing on the floor, miming the process of childbirth."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw5_5",
      "id": "wt5_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5")])]), _vm._v(" Old-fashioned snake handlers look tame by comparison.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("It is all wild nonsense; yet it is unabashedly attributed to the Holy Spirit of God, as if He were the author of confusion and the architect of disorder. Charismatic authors usually describe His presence with expressions like “a jolt of electricity”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw6_5",
      "id": "wt6_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6")])]), _vm._v(" and “a remarkable tingling, electrifying sensation [that] started to spread over my feet, up my legs, up to my head, through my arms and down to my fingers.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw7_5",
      "id": "wt7_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7")])]), _vm._v(" Never mind the fact that such descriptions have no precedent in Scripture—and Scripture itself warns us that Satan can do signs and wonders. What if all the tingling, trances, and tremors are actually evidence of "), _c('span', {
    attrs: {
      "id": "page_p0024-02-2_12_demonic"
    }
  }, [_vm._v("demonic activity")]), _vm._v("? That concern is not at all far-fetched, given the dark, outlandish, and turbulent nature of so many of these phenomena.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Even violent assaults have been committed in the Holy Spirit’s name. Kenneth Hagin says he punched a woman in the stomach in an attempt to heal"), _c('a', {
    attrs: {
      "id": "page7"
    }
  }, [_vm._v(" her because God told him to do so. Rodney Howard Browne slapped a deaf man so hard he fell to the ground. Benny Hinn regularly has people fall over violently. Sometimes he does this as if by magic, waving his coat or his hand at them. Other times he pushes them backward with considerable force. The fact that an elderly woman was once fatally injured in the process hasn’t stopped him from making this a regular feature of his miracle crusades."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw8_5",
      "id": "wt8_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8")]), _vm._v(" Unimaginably absurd "), _c('span', {
    attrs: {
      "id": "page_p0024-02-2_124_acts"
    }
  }, [_c('span', {
    attrs: {
      "id": "page_p0024-02-2_127_acts"
    }
  }, [_vm._v("acts")])]), _vm._v(" are credited to the Spirit’s influence. For example, charismatic evangelist Todd Bentley justifies his brutal healing techniques with claims like this: ")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("I said “God, I prayed for like a hundred crippled people. Not one [got healed]?” He said, “That’s because I want you to grab that lady’s crippled legs and bang them up and down on the platform like a baseball bat.” I walked up and I grabbed her legs and I started going BAM! BAM! I started banging them up and down on the platform. She got healed. And I’m thinking, “Why is not the power of God moving?” He said, “Because you haven’t kicked that woman in the face.” And there was this older lady worshipping right in front of the platform. "), _c('i', [_vm._v("And the Holy Spirit spoke to me")]), _vm._v("; the gift of faith came on me. He said “Kick her in the face—with your biker boot!” I inched closer and I went like this. BAM! And just as my boot made contact with her nose she fell under the power of God."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw9_5",
      "id": "wt9_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In spite of such outrageous comments, Bentley was hailed by charismatic leaders like Peter Wagner for his part in the 2008 "), _c('span', {
    attrs: {
      "id": "page_p0025-02-1_10_lakeland"
    }
  }, [_vm._v("Lakeland Revival")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw10_5",
      "id": "wt10_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10")])]), _vm._v(" Though his ministry temporarily stalled due to an illicit relationship with a female staff member, Bentley returned to full-time ministry just a short time later—after getting divorced and remarried.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Benny Hinn made headlines in the early 1990s when he threatened to weaponize the Holy Spirit in an attack on his critics. In a lengthy tirade during a "), _c('span', {
    attrs: {
      "id": "page_p0025-02-1_11_trinity"
    }
  }, [_vm._v("Trinity Broadcasting Network")]), _vm._v(" "), _c('i', [_vm._v("Praise-a-Thon")]), _vm._v(", Hinn retorted, “Those who put us down are a bunch of morons. . . . You know, I’ve looked for one verse in the Bible, I just can’t seem to find it. One verse that says, ‘If you don’t like’em, kill’em.’ I really wish I could find it. . . . Sometimes I wish God would give me a Holy Ghost machine gun—I’ll blow your head off!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw11_5",
      "id": "wt11_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page8"
    }
  }, [_vm._v("Though not as hostile as her husband, Benny’s wife, Suzanne, made a media splash of her own several years later when she referenced the Holy Spirit in a particularly graphic and inappropriate way. As she frantically paced back and forth on the stage, Mrs. Hinn declared: “You know what, my engines are revvin’ to go. It’s revvin’ up. How’bout yours? And if it’s not, you know what? If your engine is not revvin’ up, you know what you need? "), _c('i', [_vm._v("You need a Holy Ghost enema right up your rear end!")]), _vm._v(" Because God will not tolerate—He will not tolerate anything else.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw12_5",
      "id": "wt12_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12")]), _vm._v(" When her antics were later aired on Comedy Central’s "), _c('i', [_vm._v("The Daily Show")]), _vm._v(", Hinn’s lawyers threatened a defamation lawsuit but to no avail. She had made herself a laughingstock. In reality, the only person whose character was defamed was the Holy Spirit.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" S"), _c('span', {
    staticClass: "small"
  }, [_vm._v("PIRIT OF")]), _vm._v(" F"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RAUD")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("The Charismatic Movement claims to exalt the third member of the Trinity. Truth be told, it has turned Him into a sideshow. It would be bad enough if such blasphemy were confined to the private audience of a local congregation. But the circus of sacrilege is endlessly exported through a global network of print, radio, and television media. As former Pentecostal Kenneth D. "), _c('span', {
    attrs: {
      "id": "page_p0026-01-0_31_john"
    }
  }, [_vm._v("John")]), _vm._v("s explains, “In the past the influence of these hapless leaders has had certain limitations. Their distortion of the Bible message was limited in its dissemination to preaching in the local church, classrooms of a college or a seminary, books, and radio programs. In the last thirty to forty years all of that has changed because of television.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw13_5",
      "id": "wt13_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Influenced by TV’s most popular preachers, many charismatics treat the sovereign Spirit of God as if He were their slave—a heavenly butler bound to wait on their every command. Their teaching is not substantially different from the New Age poison popularized by the 2006 international best seller "), _c('i', [_vm._v("The Secret")]), _vm._v(", in which author Rhonda Byrne suggests, “You are the Master of the universe, and the Genie is there to serve you.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw14_5",
      "id": "wt14_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14")])]), _vm._v(" Charismatic televangelists and celebrity pastors typically preach a similar message. It is a "), _c('span', {
    attrs: {
      "id": "page_p0026-01-0_7_false"
    }
  }, [_vm._v("false gospel of")]), _vm._v(" material prosperity popularly known as Word of Faith doctrine. If you have enough faith, they claim, you can literally have whatever you say.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page9"
    }
  }, [_vm._v("In the words of Kenneth Copeland, “As a believer, you have a right to make commands in the name of Jesus. Each time you stand on the Word, you are "), _c('i', [_vm._v("commanding God")]), _vm._v(" to a certain extent.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw15_5",
      "id": "wt15_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15")]), _vm._v(" Fred Price urges his followers not to be timid or restrained in what they demand from God: “If you have to say, ‘If it be thy will’ or ‘Thy will be done’—if you have to say that, then you’re calling God a fool, because He’s the One that told us to ask. . . . If God’s gonna give me what He wants me to have, then it doesn’t matter what I ask.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw16_5",
      "id": "wt16_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("This branch of the Charismatic Movement is by far the largest, most visible, most influential, and fastest-growing category of charismatics. Put simply, Word of Faith teachers represent the current drift of the larger movement. And the doctrine of prosperity they teach has nothing whatsoever to do with the true gospel of Jesus Christ. They are promoting crass superstition blended with false doctrines purloined from assorted Gnostic and metaphysical cults, cloaked in Christian terms and symbols. It is not authentic Christianity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For the hundreds of millions who embrace Word of Faith theology and the "), _c('span', {
    attrs: {
      "id": "page_p0027-01-0_17_prosperity"
    }
  }, [_vm._v("prosperity gospel")]), _vm._v(", “the Holy Spirit is relegated to a quasi-magical power by which success and prosperity are achieved.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw17_5",
      "id": "wt17_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17")])]), _vm._v(" As one author observed, “The believer is told to use God, whereas the truth of biblical Christianity is just the opposite—God uses the believer. Word of Faith or prosperity theology sees the Holy Spirit as a power to be put to use for whatever the believer wills. The Bible teaches that the Holy Spirit is a Person who enables the believer to do God’s will.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw18_5",
      "id": "wt18_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Silver-tongued televangelists boldly promise unending health and wealth to all who have enough faith—and more important, to all who send in their money. On program after program, people are urged to “plant a seed” with the promise God will miraculously make them rich in return. It’s known as the "), _c('span', {
    attrs: {
      "id": "page_p0027-01-0_33_seed"
    }
  }, [_vm._v("seed-faith plan")]), _vm._v(", so named by Oral Roberts, the key pioneer in using television to spread charismatic doctrine. Most charismatic televangelists and faith healers use Roberts’s seed-faith plan or something similar to manipulate viewers to donate more than they can really afford."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw19_5",
      "id": "wt19_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Paul Crouch, founder and chairman of "), _c('span', {
    attrs: {
      "id": "page_p0027-01-0_12_trinity"
    }
  }, [_vm._v("Trinity Broadcasting Network")]), _vm._v(", is one of the doctrine’s staunchest defenders. “Plant a significant seed,” Crouch wrote in a 2011 TBN fund-raising letter. “Give it fully expecting the glorious"), _c('a', {
    attrs: {
      "id": "page10"
    }
  }, [_vm._v(" return that Jesus promised. One final note: name your seed—‘out of debt,’ ‘job,’ ‘home,’ ‘husband,’ ‘wife’—or whatever you desire from God!”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw20_5",
      "id": "wt20_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20")]), _vm._v(" Another letter ended with these words: “I know prices for gas and most everything else is up, but remember Jesus’ words: ‘Give and it shall be given [unto you].’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw21_5",
      "id": "wt21_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21")])]), _vm._v(" The message is anything but subtle. An article in the "), _c('i', [_vm._v("Los Angeles Times")]), _vm._v(" summarized Crouch’s approach this way:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Pastor Paul Crouch calls it “God’s economy of giving,” and here is how it works: People who donate to Crouch’s Trinity Broadcasting Network will reap financial blessings from a grateful God. The more they give TBN, the more he will give them. Being broke or in debt is no excuse not to write a check. In fact, it’s an ideal opportunity. For God is especially generous to those who give when they can least afford it. “He’ll give you thousands, hundreds of thousands,” Crouch told his viewers during a telethon last November. “He’ll give millions and billions of dollars.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw22_5",
      "id": "wt22_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("For Crouch and others at the top of this pyramid scheme, prosperity theology works flawlessly. Viewers send in billions of dollars,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw23_5",
      "id": "wt23_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23")])]), _vm._v(" and when there is no return on investment, God is the one held liable."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw24_5",
      "id": "wt24_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24")])]), _vm._v(" Or the people who have sent money are blamed for some defect in their faith when the sought-after miracle never materializes."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw25_5",
      "id": "wt25_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25")])]), _vm._v(" Disappointment, frustration, poverty, sorrow, anger, and ultimately unbelief are the main fruits of this kind of teaching, but the pleas for money only get more urgent and the false promises grow more exaggerated. ")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Masked in the language of faith and generosity, the entire charade is a deceptive ruse designed to exploit the greedy and swindle the desperate."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw26_5",
      "id": "wt26_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26")])]), _vm._v(" It has replaced the Spirit of God with a spirit of fraud"), _c('i', [_vm._v(".")]), _vm._v(" Even so, its message of false hope remains extremely popular, and it’s easy to see why: "), _c('i', [_vm._v("the promise of physical well-being, material riches, and a life of ease appeals to the flesh.")]), _vm._v(" It is pure carnality; there’s nothing truly spiritual about it.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("More moderate prosperity preachers, like Joel Osteen, salt their sermons with subtlety and a smile. But the underlying message is still the same: God is here to make our dreams come true. Michael Horton puts it succinctly: “Osteen represents a variety of the moralistic, therapeutic deism that in less"), _c('a', {
    attrs: {
      "id": "page11"
    }
  }, [_vm._v(" extreme versions seems to characterize much of popular religion in America today. Basically, God is there for you and your happiness. He has some rules and principles for getting what you want out of life, and if you follow them, you can have what you want. Just "), _c('i', [_vm._v("declare it")]), _vm._v(" and prosperity will come to you.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw27_5",
      "id": "wt27_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27")]), _vm._v(" From a "), _c('span', {
    attrs: {
      "id": "page_p0028-02-2_52_mark"
    }
  }, [_vm._v("mark")]), _vm._v("eting perspective, it’s an effective formula. Blank-check promises of health and wealth, mixed with inane doses of positive thinking and shallow platitudes, may boost ratings and sell books. But it is all a massive swindle, and it has nothing to do with biblical Christianity.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In hawking their "), _c('span', {
    attrs: {
      "id": "page_p0029-02-2_30_gospel"
    }
  }, [_vm._v("gospel of")]), _vm._v(" greed, materialism, and self-promotion, Word of Faith teachers have made lucrative careers out of bad theology—backing up their false teachings by twisting the Scriptures or claiming new revelation from God. Some go so far as to assert that believers are "), _c('i', [_vm._v("little gods")]), _vm._v(" who can speak their worldly desires into existence."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw28_5",
      "id": "wt28_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28")])]), _vm._v(" Paul Crouch responded to naysayers on national television with these words: “I am a little god. I have His name. I am one with Him. I’m in covenant relation. I am a little god. Critics be gone!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw29_5",
      "id": "wt29_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29")])]), _vm._v(" Kenneth Copeland similarly told his listeners, “You’re all god. You don’t have a God living in you; you "), _c('i', [_vm._v("are")]), _vm._v(" one! You are part and parcel of God.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw30_5",
      "id": "wt30_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30")])]), _vm._v(" More recently, televangelist Creflo Dollar echoed the teachings of Copeland and Crouch: “I’m going to say something, "), _c('i', [_vm._v("we are gods")]), _vm._v(", in this earth, and it’s about time we start operating like gods instead of a bunch of mere powerless humans.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw31_5",
      "id": "wt31_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31")])]), _vm._v(" Only one adjective fully describes that level of blasphemous arrogance: "), _c('i', [_vm._v("satanic")]), _vm._v(" (cf. Gen. 3:5).")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("While elevating themselves to divine status, Word of Faith teachers simultaneously deny the sovereignty of the true God."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw32_5",
      "id": "wt32_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32")])]), _vm._v(" As Myles Munroe announced to a TBN audience, “God cannot do anything in the earth without a human’s permission!”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw33_5",
      "id": "wt33_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33")])]), _vm._v(" Andrew Womack, whose television show "), _c('i', [_vm._v("The Gospel Truth")]), _vm._v(" airs daily on Trinity Broadcasting Network, insists God lost His authority in this world by delegating it to Adam and the human race. As a result, the Holy Spirit was powerless to bring Jesus into physical existence; He was forced to wait until willing human participants made the incarnation possible by speaking the right faith-words.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In a 2009 broadcast Womack told his viewers, “The reason it took four thousand years for Jesus to come on the scene is because it took four thousand"), _c('a', {
    attrs: {
      "id": "page12"
    }
  }, [_vm._v(" years for God to find enough people who would yield to Him, who would speak, and who would deliver the words that needed to be said—God-inspired words—to create this physical body of the Lord Jesus. . . . The Holy Spirit took these words and impregnated Mary.”"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw34_5",
      "id": "wt34_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34")]), _vm._v(" That is heretical teaching, with no basis whatsoever in Scripture. It comes straight out of the twisted imagination of the speaker. Worse yet, it blatantly demeans the Holy Spirit—as if God needed help from sinful people to send His Son to this world.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Examples like those could be multiplied many times over. Sadly, within the broader Charismatic Movement, such atrocities against the Holy Spirit are not the exception; they have become the rule. Peter Masters accurately describes the trend:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("With unbelievable rapidity charismatics have lurched from one excess to another, so that now we are confronted by a scene of utter confusion. Many in the charismatic fraternity have gone over to ideas and practices which come straight from pagan religions, and large numbers of young and impressionable believers have been spiritually corrupted in the process. Leading healers have arisen who unite the subtle tricks of the theatrical hypnotist with ancient occult techniques in their quest for results, and multitudes follow them."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw35_5",
      "id": "wt35_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Significantly, those words were penned more than two decades ago, around the same time I wrote "), _c('i', [_vm._v("Charismatic Chaos")]), _vm._v("."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw36_5",
      "id": "wt36_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36")])]), _vm._v(" In the years since, the situation has grown dramatically worse.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("I"), _c('span', {
    staticClass: "small"
  }, [_vm._v("N")]), _vm._v(" G"), _c('span', {
    staticClass: "small"
  }, [_vm._v("OLD")]), _vm._v(" W"), _c('span', {
    staticClass: "small"
  }, [_vm._v("E")]), _vm._v(" T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("RUST")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("There is no escaping the fact that all sorts of spiritual deception, theological error, and outright skulduggery find shelter within the broader charismatic world—including the bald materialism and brash self-centeredness of the prosperity gospel. Some might argue, however, that such heretical elements represent only the lunatic fringe of an otherwise orthodox movement."), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v(" More moderate charismatics like to portray the prosperity preachers, faith healers, and televangelists as safely isolated on the extreme edge of the charismatic camp.")])]), _c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_c('p', {
    staticClass: "tx"
  }, [_vm._v("Unfortunately, that is not the case. Thanks to the global reach and incessant proselytizing of religious television and charismatic mass media, the "), _c('i', [_vm._v("extreme")]), _vm._v(" has now become "), _c('i', [_vm._v("mainstream")]), _vm._v(". For most of the watching world, flamboyant false teachers—with heresies as ridiculous as their hairdos—constitute the public face of Christianity. And they propagate their lies in the Holy Spirit’s name.")])]), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page13"
    }
  }, [_vm._v("When it comes to religious broadcasting, Satan is indeed the prince of the power of the air(waves). On networks like TBN, almost no false prophecy, erroneous doctrine, rank superstition, or silly claim is too outlandish to receive airtime. Jan Crouch tearfully gives a fanciful account of how her pet chicken was miraculously raised from the dead."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw37_5",
      "id": "wt37_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37")]), _vm._v(" Benny Hinn trumps that claim with a bizarre prophecy that if TBN viewers will put the caskets of their dead loved ones in front of a television set and touch the dead person’s hand to the screen, people will “be raised from the dead . . . by the thousands.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw38_5",
      "id": "wt38_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38")])]), _vm._v(" Ironically, one doesn’t even need to be an orthodox trinitarian in order to broadcast on the "), _c('span', {
    attrs: {
      "id": "page_p0031-02-2_13_trinity"
    }
  }, [_vm._v("Trinity Broadcasting Network")]), _vm._v(". Bishop T. D. Jakes, well known for his association with "), _c('span', {
    attrs: {
      "id": "page_p0031-02-2_7_oneness"
    }
  }, [_vm._v("Oneness Pentecostalism")]), _vm._v(","), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw39_5",
      "id": "wt39_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39")])]), _vm._v(" is a staple on TBN. And though he later recanted, Benny Hinn infamously told TBN listeners there are nine persons in the Godhead."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw40_5",
      "id": "wt40_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As the largest religious television network on the planet, TBN beams its product 24/7 to more than one hundred countries on seventy satellites through more than eighteen thousand TV channels and cable affiliates."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw41_5",
      "id": "wt41_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("41")])]), _vm._v(" Its Internet presence extends that reach even farther. The media organization claims to be empowered by the Holy Spirit to reach “a troubled world with the hope of the gospel.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw42_5",
      "id": "wt42_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("42")])]), _vm._v(" But it is the "), _c('i', [_vm._v("false")]), _vm._v(" hope of a "), _c('i', [_vm._v("false")]), _vm._v(" gospel. Virtually all the network’s main celebrities advocate prosperity theology—telling listeners that God will give them healing, wealth, and other material blessings in return for their money. And TBN is not the only culprit. The network’s major competitors (like Daystar and LeSEA) provide similar platforms for Word of Faith teachers.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page14"
    }
  }, [_vm._v("So is it any wonder the health-and-wealth prosperity gospel has taken our planet by storm?"), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw43_5",
      "id": "wt43_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("43")]), _vm._v(" In the Two-Thirds World of Asia, Africa, and Latin America—where the Charismatic Movement is growing at an unprecedented rate—experts estimate well over half of Pentecostal and charismatic adherents hold to the prosperity gospel."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw44_5",
      "id": "wt44_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("44")])]), _vm._v(" As "), _c('span', {
    attrs: {
      "id": "page_p0032-01-0_58_john"
    }
  }, [_vm._v("John")]), _vm._v(" T. Allen explains:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("Perhaps the most controversial element of the Pentecostal outlook is the so-called “prosperity gospel,” meaning the belief that God will reward those with sufficient faith with both material prosperity and physical health. Some analysts distinguish between “neo-Pentecostal,” which they see as focused on the prosperity gospel, and classic Pentecostalism, oriented toward the gifts of the Spirit such as healings and tongues. Yet the "), _c('span', {
    attrs: {
      "id": "page_p0032-01-0_20_pew"
    }
  }, [_vm._v("Pew Forum")]), _vm._v(" data suggests that the prosperity gospel is actually a defining feature of all Pentecostalism; majorities of Pentecostals exceeding 90 percent in most countries hold to these beliefs."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw45_5",
      "id": "wt45_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("45")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("In reality, the rapid expansion of charismatic theology is primarily due to the popularity of the prosperity gospel. It is not the convicting work of the Holy Spirit that is drawing converts, but the allure of material possessions"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw46_5",
      "id": "wt46_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("46")])]), _vm._v(" and the hope of physical healing."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw47_5",
      "id": "wt47_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("47")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The fastest-growing and largest charismatic congregations all preach some form of this message,"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw48_5",
      "id": "wt48_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("48")])]), _vm._v(" from David Yonggi Cho in South Korea, whose church claims more than eight hundred thousand members, to Bishop Enoch Adeboye of Nigeria, whose monthly prayer meetings regularly draw three hundred thousand in attendance. Pentecostal historian Vinson Synan, clearly thrilled by the surging numbers, wrote, “Generally known as the ‘prosperity gospel’ or the ‘Word of Faith Movement,’ this movement is now an international force that is gaining millions of enthusiastic followers around the world. Led by popular teachers and evangelists such as Kenneth Copeland, David Yonggi Cho and Reinhard Bonnke, the teaching has inspired some of the largest churches and evangelistic crusades in the history of the Church.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw49_5",
      "id": "wt49_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("49")])]), _vm._v(" The global success of the Word of Faith Movement has made the Pentecostal-Charismatic Movement the fastest-growing religious movement in the world."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw50_5",
      "id": "wt50_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("50")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_c('a', {
    attrs: {
      "id": "page15"
    }
  }, [_vm._v("Of course, the "), _c('span', {
    attrs: {
      "id": "page_p0033-01-0_18_prosperity"
    }
  }, [_vm._v("prosperity gospel")]), _vm._v("’s enthusiastic reception is not limited to churches outside the United States. Even on American soil, it is one of the fastest-growing segments of Christianity."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw51_5",
      "id": "wt51_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("51")]), _vm._v(" High-profile pastors, leading some of the nation’s largest churches, shamelessly promote a gospel of health, wealth, and happiness—from Joel Osteen to Joyce Meyer to T. D. Jakes. Their influence is permanently altering the American religious landscape: “The prosperity gospel is spreading beyond the confines of the charismatic movement, where it has been traditionally strong, and is taking root in the larger evangelical church. A recent survey found that in the United States, 46 percent of self-proclaimed Christians agree with the idea that God will grant material riches to all believers who have enough faith.”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw52_5",
      "id": "wt52_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("52")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Though the church has historically repudiated "), _c('span', {
    attrs: {
      "id": "page_p0033-01-0_29_greed"
    }
  }, [_vm._v("greed")]), _vm._v(" and "), _c('span', {
    attrs: {
      "id": "page_p0033-01-0_24_consumerism"
    }
  }, [_vm._v("consumerism")]), _vm._v(", that appears to be changing quickly."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw53_5",
      "id": "wt53_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("53")])]), _vm._v(" Nearly half of American Christians, in any denomination, and roughly two-thirds of American Pentecostals now embrace the basic premise of the prosperity gospel: God wants you to be happy, healthy, and rich."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw54_5",
      "id": "wt54_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("54")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Recent studies estimate the total number of Pentecostals and charismatics worldwide at just over 500 million—with 80 million in North America, 141 million in Latin America, 135 million in Asia, 126 million in Africa, and 38 million in Europe."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw55_5",
      "id": "wt55_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("55")])]), _vm._v(" Those numbers initially sound impressive, suggesting charismatic Christianity represents one-fourth of global Christendom."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw56_5",
      "id": "wt56_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("56")])]), _vm._v(" The reality is that the vast majority of Pentecostals and charismatics—measuring in the hundreds of millions—embrace some form of the prosperity gospel. In terms of raw numbers alone, health-and-wealth theology has become the larger movement’s defining feature."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw57_5",
      "id": "wt57_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("57")])]), _vm._v(" As Ted Olsen observed in "), _c('i', [_vm._v("Christianity Today")]), _vm._v(", most Pentecostals and charismatics “overwhelmingly agree that ‘God will grant material prosperity to all believers who have enough faith.’”"), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw58_5",
      "id": "wt58_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("58")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("The "), _c('span', {
    attrs: {
      "id": "page_p0033-01-0_1_health"
    }
  }, [_vm._v("health-and-wealth prosperity gospel")]), _vm._v(" may be popular, but it is "), _c('i', [_vm._v("not")]), _vm._v(" the true gospel. David Jones and Russell Woodbridge note the stark contrasts:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("The message preached in some of the largest churches in the world has changed. A new gospel is being taught today. This new gospel is perplexing—it omits "), _c('a', {
    attrs: {
      "id": "page16"
    }
  }, [_vm._v("Jesus and neglects the cross. Instead of promising Christ, this gospel promises health and wealth, and offers advice such as: declare to yourself that everything that you touch will prosper, for, in the words of a leading prosperity gospel preacher, “There is a miracle in your mouth.” According to this new gospel, if believers repeat positive confessions, focus their thoughts, and generate enough faith, God will release blessings upon their lives."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw59_5",
      "id": "wt59_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("59")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Such a gospel is powerless to save. It is empowered by human desire, not the Holy Spirit. Moreover, it offers temporal relief at the expense of eternal life. And even then, except for those in the highest positions of leadership, it rarely delivers as advertised.")]), _vm._v(" "), _c('p', {
    staticClass: "h3"
  }, [_vm._v("T"), _c('span', {
    staticClass: "small"
  }, [_vm._v("HE")]), _vm._v(" H"), _c('span', {
    staticClass: "small"
  }, [_vm._v("EART OF THE")]), _vm._v(" P"), _c('span', {
    staticClass: "small"
  }, [_vm._v("ROBLEM")])]), _vm._v(" "), _c('p', {
    staticClass: "tx1"
  }, [_vm._v("Without question, the prosperity gospel is a “different gospel,” which is really no gospel at all (Gal. 1:6–8). But how has such blatant heresy managed to not only survive but flourish in charismatic circles? The answer points to a critical and systemic "), _c('span', {
    attrs: {
      "id": "page_p0034-02-1_0_defect"
    }
  }, [_vm._v("defect within")]), _vm._v(" charismatic theology—a flaw that accounts for just about every theological aberration or abnormality that makes its home within the Charismatic Movement. It is this: "), _c('i', [_vm._v("Pentecostals and charismatics elevate religious experience over biblical truth.")]), _vm._v(" Though many of them pay lip service to the "), _c('span', {
    attrs: {
      "id": "page_p0034-02-1_4_authority"
    }
  }, [_vm._v("authority of")]), _vm._v(" God’s Word, in practice they deny it."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw60_5",
      "id": "wt60_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("60")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("If Scripture alone were truly their final authority, charismatic Christians would never tolerate patently unbiblical practices—like mumbling in nonsensical prayer languages, uttering fallible prophecies, worshipping in disorderly ways, or being knocked senseless by the supposed power of the Holy Spirit. They ought to reinterpret their experiences to match the Bible; instead, they reinterpret Scripture in novel and unorthodox ways in order to justify their experiences."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw61_5",
      "id": "wt61_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("61")])]), _vm._v(" As a result, any aberrant teaching or practice can be legitimized, especially when a new “revelation from God” conveniently authenticates it as having His approval. Though written nearly a half century ago, the words of René Pache still ring true:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_c('a', {
    attrs: {
      "id": "page17"
    }
  }, [_vm._v("The excessive preeminence given to the Holy Spirit in their devotions and their preoccupation with gifts, ecstasies, and “prophecies” has tended to neglect of the Scriptures. Why be tied to a Book out of the past when one can communicate every day with the living God? But this is exactly the danger point. Apart from the constant control of the written revelation, we soon find ourselves engulfed in subjectivity; and the believer, even if he has the best intentions, can sink rapidly into deviations, illuminism or exaltation. Let each remind himself of the prohibition of taking anything away from Scripture or adding anything to it (Deut. 4:2; Rev. 22:18"), _c('span', {
    attrs: {
      "id": "page_p0035-01-0_73_amp"
    }
  }, [_vm._v("–19")]), _vm._v("). Almost every heresy and sect has originated in a supposed revelation or a new experience on the part of its founder, something outside the strictly biblical framework."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw62_5",
      "id": "wt62_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("62")])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("By abandoning the final authority of the text, the Charismatic Movement has made itself susceptible to the worst kinds of doctrinal deception and spiritual exploitation."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw63_5",
      "id": "wt63_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("63")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Other aspects of charismatic theology only exacerbate the problem: the labeling of church leaders as "), _c('i', [_vm._v("prophets")]), _vm._v(" and "), _c('i', [_vm._v("apostles")]), _vm._v(", the constant hunt for miracles and supernatural events, the desire to encounter God in mystical ways, and the willingness to bypass the mind in worship. With its lack of biblical controls and its emphasis on experience-driven subjectivism, the Charismatic Movement is custom-made for false teachers and spiritual con men."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw64_5",
      "id": "wt64_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("64")])]), _vm._v(" Even those as blatantly blasphemous as the prosperity preachers feel welcome within its borders.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("As troubling as they are, the constant shenanigans that go on within charismatic circles are merely symptoms of this deeper issue. In fact, I believe it is the elevation of experience over the authority of Scripture that grieves and demeans the Holy Spirit most of all. It is the Spirit who inspired the Word of God (2 "), _c('span', {
    attrs: {
      "id": "page_p0035-01-0_166_peter"
    }
  }, [_vm._v("Peter 1:19–21")]), _vm._v(") and who illuminates its truth in the hearts of His people (1 Cor. 2:10–15). Thus, it is a brazen affront to His authority to claim an experience of His power that goes contrary to His Word. To twist the Scriptures that He inspired, or to ignore them altogether, is to treat Him with disdain and disrespect. Yet that is exactly what happens throughout the charismatic"), _c('a', {
    attrs: {
      "id": "page18"
    }
  }, [_vm._v(" world every single day—from the rankest heresies of the leading televangelists to the private revelations of self-styled prophets in small congregations."), _c('sup')]), _c('span', {
    attrs: {
      "href": "#/chapter21#tw65_5",
      "id": "wt65_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("65")]), _vm._v(" It is "), _c('i', [_vm._v("all")]), _vm._v(" an insult to the true person and work of the Holy Spirit. Christopher Wright says it well:")]), _vm._v(" "), _c('p', {
    staticClass: "ext"
  }, [_vm._v("There are the televangelists and purveyors of prosperity “gospel” (an abuse of the term, since it is far from good news), appealing to and exploiting for profit, people’s innate material greed in the name of God’s blessing. Add to that the inflated claims and grossly insensitive publicity of some of the great “healing miracle merchants.” And even at the lowly level of ordinary local churches there are those who abuse the Holy Spirit by claiming his authority for their latest “revelation” or for the latest fashionable theory, style, song, or method."), _c('sup', [_c('span', {
    attrs: {
      "href": "#/chapter21#tw66_5",
      "id": "wt66_5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("66")])])]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("And that brings us back to where we began this chapter. It is deeply ironic that the movement most concerned with emphasizing the Holy Spirit is, in fact, the one that treats Him with the greatest contempt and condescension.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6061275e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/chapter5.vue
// module id = 78
// module chunks = 0